import { useMemo } from 'react';
import { getProjectKeyOrId } from '@jira/router-resources__utils/src/getProjectKeyOrId.tsx';
import type { DataState } from '@atlassian/jira-common-services/src/types.tsx';
// eslint-disable-next-line jira/import-whitelist
import { useResourceWithCustomRouterContext } from '@jira/platform__routing-router-resource-with-custom-router-context/src/controllers/use-resource-with-custom-router-context/index.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';

const RESOURCE_TYPE_SERVICEDESK_IS_ITSM_PROJECT = 'SERVICEDESK_IS_ITSM_PROJECT';

const ONE_DAY_IN_MILLIS = 24 * 60 * 60 * 1000;

export const servicedeskIsItsmProjectResource: RouteResource<boolean> = createResource<boolean>({
	type: RESOURCE_TYPE_SERVICEDESK_IS_ITSM_PROJECT,
	getKey: ({ match }) => getProjectKeyOrId(match),
	getDataLoader: () =>
		import(
			/* webpackChunkName: "async-resource-servicedesk-is-itsm-project", jiraSpaEntry: "async-resource-servicedesk-is-itsm-project" */ './getData.tsx'
		),
	maxAge: ONE_DAY_IN_MILLIS,
});

export const useIsItsmTemplateProject = (projectKey?: string): DataState<boolean> => {
	const { data, loading, error } = useResourceWithCustomRouterContext(
		servicedeskIsItsmProjectResource,
		projectKey ? { matchParams: { projectKey } } : undefined,
		{
			shouldPrefetch: true,
		},
	);

	return useMemo(
		() => ({
			data,
			loading,
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			error: error as Error,
		}),
		[data, loading, error],
	);
};
